<h1>Analisar inscrição</h1>

<mat-card>
  <mat-card-content fxLayout="column" fxLayoutGap="20px">
    <fieldset fxFlex="100%">
      <legend>Aluno</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Nome</mat-label>
            <input matInput value="{{ inscricao?.nome }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>CPF</mat-label>
            <input matInput value="{{ inscricao?.cpf }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Programa</mat-label>
            <input matInput value="{{ inscricao?.programa }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Curso</mat-label>
            <input matInput value="{{ inscricao?.curso }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input matInput value="{{ inscricao?.campus }}" readonly="readonly" />
          </mat-form-field>
        </div>
      </form>
    </fieldset>

    <fieldset fxFlex="100%">
      <legend>Disciplina</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Disciplina</mat-label>
            <input matInput value="{{ inscricao?.nomeDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Código</mat-label>
            <input matInput value="{{ inscricao?.codigoDisciplina }}" readonly="readonly" />
          </mat-form-field>
        </div>

        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>Duração</mat-label>
            <input matInput value="{{ inscricao?.duracao }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Carga horária</mat-label>
            <input matInput value="{{ inscricao?.cargaHoraria }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Departamento</mat-label>
            <input matInput value="{{ inscricao?.departamentoDisciplina }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Unidade</mat-label>
            <input
              matInput
              value="{{ inscricao?.campusDisciplina }} - {{ inscricao?.siglaDisciplina }}"
              readonly="readonly" />
          </mat-form-field>
        </div>
      </form>
    </fieldset>

    <!-- A partir de 2023, quando o semestre é definido pelo docente na liberação da disciplina e o discente escolhe no ato da inscrição -->
    <fieldset fxFlex="100%" *ngIf="inscricao?.semestreJaDefinido">
      <legend>Inscrição</legend>
      <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
        <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
          <mat-form-field appearance="outline">
            <mat-label>1 semestre</mat-label>
            <input matInput value="{{ inscricao?.semestre1 ? 'Sim' : 'Não' }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>2 semestre</mat-label>
            <input matInput value="{{ inscricao?.semestre2 ? 'Sim' : 'Não' }}" readonly="readonly" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Situação</mat-label>
            <mat-select formControlName="aprovado" (selectionChange)="alteraSituacao($event)">
              <mat-option value="">Aguardando análise</mat-option>
              <mat-option value="sim">Aprovada</mat-option>
              <mat-option value="rep">Reprovada</mat-option>
              <mat-option value="can">Cancelada</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-form-field
          appearance="outline"
          *ngIf="form.controls['aprovado'].value === 'rep' || form.controls['aprovado'].value === 'can'">
          <mat-label>Motivo</mat-label>
          <textarea matInput formControlName="motivo" rows="3"></textarea>
        </mat-form-field>
      </form>
    </fieldset>

    <!-- Inscrição feita na versão antiga do sistema, o semestre 1 ou 2 será definido pelo departamento -->
    <div *ngIf="!inscricao?.semestreJaDefinido">
      <!-- Quando existe a oferta para a disciplina -->
      <fieldset fxFlex="100%" *ngIf="inscricao?.oferta1Semestre || inscricao?.oferta2Semestre">
        <legend>Inscrição</legend>
        <form [formGroup]="form" fxLayout="column" fxLayoutGap="5px">
          <mat-card class="info">
            <p>Informe em qual semestre o discente irá participar.</p>
          </mat-card>
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>1 semestre</mat-label>
              <mat-select formControlName="semestre1">
                <mat-option *ngIf="inscricao?.oferta1Semestre"></mat-option>
                <mat-option value="1" *ngIf="inscricao?.oferta1Semestre">Sim</mat-option>
                <mat-option value="0">Não</mat-option>
              </mat-select>
              <mat-hint *ngIf="!inscricao?.oferta1Semestre">Semestre não ofertado no SISGRAD.</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>2 semestre</mat-label>
              <mat-select formControlName="semestre2">
                <mat-option *ngIf="inscricao?.oferta2Semestre"></mat-option>
                <mat-option value="1" *ngIf="inscricao?.oferta2Semestre">Sim</mat-option>
                <mat-option value="0">Não</mat-option>
              </mat-select>
              <mat-hint *ngIf="!inscricao?.oferta2Semestre">Semestre não ofertado no SISGRAD.</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Situação</mat-label>
              <mat-select formControlName="aprovado" (selectionChange)="alteraSituacao($event)">
                <mat-option value="">Aguardando análise</mat-option>
                <mat-option value="sim">Aprovada</mat-option>
                <mat-option value="rep">Reprovada</mat-option>
                <mat-option value="can">Cancelada</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field
            appearance="outline"
            *ngIf="form.controls['aprovado'].value === 'rep' || form.controls['aprovado'].value === 'can'">
            <mat-label>Motivo</mat-label>
            <textarea matInput formControlName="motivo" rows="3"></textarea>
          </mat-form-field>
        </form>
      </fieldset>

      <!-- Quando não existe a oferta da disciplina em nenhum semestre -->
      <mat-card class="info" *ngIf="!inscricao?.oferta1Semestre && !inscricao?.oferta2Semestre">
        <p>Esta disciplina não foi ofertada em nenhum semestre no SISGRAD.</p>
      </mat-card>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayoutAlign="space-between center">
      <button
        mat-raised-button
        color="primary"
        (click)="gravar()"
        *ngIf="inscricao?.semestreJaDefinido || inscricao?.oferta1Semestre || inscricao?.oferta2Semestre">
        <mat-icon>save</mat-icon> Gravar
      </button>
      <button mat-stroked-button color="warn" routerLink="/departamento/aprovar-inscricao">
        <mat-icon>close</mat-icon> Cancelar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
